import { EditText } from '../../../../component/ui/edit-text/edit-text';
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { SettingsServicePaymentType } from '../../../../api/types/settings/payments/settings-service-payment-type';
import { addNewServiceOperation } from '../operations/add-new-service-operation';
import { PaymentTypeSelectionDialog } from './payment-type-selection-dialog';

export interface AddPaymentServiceDialogModel {
  closeDialog: () => void;
}

export const AddPaymentServiceDialog: React.FC<
  AddPaymentServiceDialogModel
> = ({ closeDialog }) => {
  const [serviceName, setServiceName] = useState('');
  const [price, setPrice] = useState<number | null>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const [selectedPaymentServiceType, setSelectedPaymentServiceType] =
    useState<SettingsServicePaymentType | null>(null);

  // Payment type selection dialog state
  const [showTypeSelectionDialog, setShowTypeSelectionDialog] = useState(false);

  const openTypeSelectionDialog = () => {
    setShowTypeSelectionDialog(true);
  };

  const handleApproveSelection = (
    selected: SettingsServicePaymentType | null,
  ) => {
    setSelectedPaymentServiceType(selected);
    setShowTypeSelectionDialog(false);
  };

  const handleCancelSelection = () => {
    setShowTypeSelectionDialog(false);
  };

  const handleOnSubmit = async () => {
    await addNewServiceOperation(
      serviceName,
      price,
      selectedPaymentServiceType,
      setLoading,
      closeDialog,
    );
  };

  return (
    <div>
      <EditText
        title={'שם השרות'}
        onChange={setServiceName}
        height={'43.5px'}
      />
      <div
        style={{
          flex: '1', // Flex-grow, flex-shrink, and base size of 250px
          minWidth: '250px', // Ensure a minimum width of 250px
          marginTop: '16px',
          marginBottom: '16px', // Optional bottom margin for row spacing
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ fontSize: '14px', color: '#4b5563' }}>סכום</div>
        <InputNumber
          style={{ direction: 'ltr', width: '100%', marginTop: '8px' }}
          inputStyle={{ direction: 'rtl' }}
          inputId="currency-us"
          value={price}
          onValueChange={(e) => setPrice(e.value)}
          mode="currency"
          currency="NIS"
          showButtons
          locale="en-US"
        />
      </div>

      <div
        style={{
          flex: '1',
          minWidth: '250px',
          marginTop: '16px',
          marginBottom: '16px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ fontSize: '14px', color: '#4b5563' }}>בחירת סוג שרות</div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginTop: '8px',
          }}
        >
          <Button
            label={
              selectedPaymentServiceType
                ? selectedPaymentServiceType.paymentServiceTypeName
                : 'בחר סוג שרות'
            }
            icon="pi pi-list"
            onClick={openTypeSelectionDialog}
            outlined={!selectedPaymentServiceType}
            style={{ flex: 1 }}
          />
          {selectedPaymentServiceType && (
            <Button
              icon="pi pi-times"
              severity="danger"
              text
              onClick={() => setSelectedPaymentServiceType(null)}
              tooltip="הסר בחירה"
            />
          )}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'left' }}>
        <Button label="אישור" onClick={handleOnSubmit} loading={loading} />
      </div>

      {/* Payment Type Selection Dialog */}
      <PaymentTypeSelectionDialog
        visible={showTypeSelectionDialog}
        selectedType={selectedPaymentServiceType}
        onHide={handleCancelSelection}
        onApprove={handleApproveSelection}
      />
    </div>
  );
};
